// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WYDD","tabsBox":"styles_tabsBox__2xaSO","createButton":"styles_createButton__3eL6K"};